export const activityTypes = {
  GET_ACTIVITY: "activity/GET_ACTIVITY",
  GET_ACTIVITY_SUCCESS: "activity/GET_ACTIVITY_SUCCESS",
};

export const getActivityList = (payload) => ({
  type: activityTypes.GET_ACTIVITY,
  payload,
});
